import axios from "axios";
import moment from "moment";

export const LoadForecastDataAPI = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/forecast-load/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    if (response?.data && Array.isArray(response.data)) {
      response.data = response.data.map((item) => ({
        ...item,
        forecast_timestamp: moment(item.forecast_timestamp).parseZone().format('YYYY-MM-DD HH:mm:ss'),
      }));
    }
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err;
  }
};
export const SolarForecastDataAPI = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/forecast-solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });

    if (response?.data && Array.isArray(response.data)) {
      response.data = response.data.map((item) => ({
        ...item,
        forecast_timestamp: moment(item.forecast_timestamp).parseZone().format('YYYY-MM-DD HH:mm:ss'),
      }));
    }
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};